"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduceLoading;

var _context = require("../../constants/reducers/context");

function reduceLoading(payload) {
    if (!payload.code) {
        var payloadValue = payload === true;

        payload = {
            code: '(global)',
            value: payloadValue
        };
    }

    return {
        type: _context.REDUCE_LOADING,
        payload: {
            code: payload.code,
            value: payload.value
        }
    };
}